'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// import {slide as Menu} from 'react-burger-menu'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _components = require('../../components');

var _FundMenu = require('./FundMenu.css');

var _FundMenu2 = _interopRequireDefault(_FundMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FundMenu = (_dec = (0, _reactCssModules2.default)(_FundMenu2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FundMenu, _Component);

  function FundMenu(props) {
    (0, _classCallCheck3.default)(this, FundMenu);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FundMenu.__proto__ || (0, _getPrototypeOf2.default)(FundMenu)).call(this, props));

    _this.clickMenu = function () {
      _this.setState({ menuOpen: !_this.state.menuOpen });
    };

    _this.isActive = function (title) {
      return title === _this.props.active;
    };

    _this.state = {
      menuOpen: false
    };
    return _this;
  }

  (0, _createClass3.default)(FundMenu, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var ticker = this.props.ticker || 'N';
      var name = _format2.default.sanitize(this.props.name);
      var urlStart = _config2.default.routes.fund + '/' + name + '/' + ticker;
      var urlEnd = this.props.fundId + '/' + this.props.investmentVehicleId;
      var fossilsUrl = urlStart + '/fossil-fuel-investments/' + urlEnd;
      var financeUrl = urlStart + '/fossil-finance-insurance/' + urlEnd;
      var cleanUrl = urlStart + '/clean200-investments/' + urlEnd;
      var carbonUrl = urlStart + '/carbon-footprint/' + urlEnd;
      var profileUrl = urlStart + '/investment-profile/' + urlEnd;

      var menuConfig = [[fossilsUrl, 'Fossil fuels'], [financeUrl, 'Banks & insurers'], [cleanUrl, 'Clean200'], [profileUrl, 'More'], [carbonUrl, 'Carbon footprint', _react2.default.createElement(
        'span',
        { styleName: 'deprecated-option' },
        'Carbon footprint',
        _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-exclamation-triangle' })
      )]];

      return _react2.default.createElement(
        _components.ContainerDivs,
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'menu-links' },
          menuConfig.map(function (e, i) {
            var url = e[0];
            var label = e[1];
            return _react2.default.createElement(
              'div',
              {
                styleName: _this2.isActive(label) ? 'menu-link-active' : 'menu-link',
                key: 'menu-' + i
              },
              _react2.default.createElement(
                _components.Link,
                { to: url, title: label },
                _react2.default.createElement(
                  'div',
                  { styleName: 'menu-link-flex' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'menu-link-label' },
                    e[2] || label
                  )
                )
              )
            );
          })
        )
      );
    }
  }]);
  return FundMenu;
}(_react.Component), _class2.propTypes = {
  active: _react.PropTypes.string.isRequired,
  fundId: _react.PropTypes.string.isRequired,
  investmentVehicleId: _react.PropTypes.string.isRequired,
  name: _react.PropTypes.string.isRequired,
  ticker: _react.PropTypes.string
}, _temp)) || _class);
exports.default = FundMenu;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FundMenu/FundMenu.js
// module id = 1381
// module chunks = 0